import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../services/firebase';

/**
 * Admin-side live read of the `correction_requests` collection.
 *
 * Mirrors `useOpenEntityRequestsCount` in useEntityRequestsAdmin.ts: a single
 * equality filter with no `orderBy`, so it needs no composite index. The
 * CorrectionRequestsManager list itself is still a one-shot `getDocs` that
 * refetches after each action — this subscription is what keeps the nav badge
 * decrementing as requests are actioned.
 *
 * Non-admins fail the read rule; the error path just parks the count at 0 so
 * the badge stays hidden rather than throwing on the dashboard.
 */
export function usePendingCorrectionRequestsCount(): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const q = query(
      collection(db, 'correction_requests'),
      where('status', '==', 'pending'),
    );
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => setCount(snapshot.size),
      (err) => {
        console.warn('Pending correction requests count unavailable:', err);
        setCount(0);
      },
    );
    return unsubscribe;
  }, []);

  return count;
}
